export default "__VITE_ASSET__76280029__"